import { Undef } from 'types/UtilityTypes';
import captureException from 'utils/captureException';

import { QuotingPortal } from './interface';

export const OTMSubmitAction = 'otm-submit-quote';
export class OTM implements QuotingPortal {
  allFrames = true;
  submitAction = OTMSubmitAction;
  /**
   * Determines if a quote can be submitted to OTM based on the current tab and document state.
   * @param tab The current Chrome tab
   * @param html The current document HTML
   * @returns boolean indicating if a quote can be submitted
   */
  canSubmit(tab: Undef<chrome.tabs.Tab>, html: string): boolean {
    if (!tab?.url) {
      return false;
    }

    try {
      const url = new URL(tab.url);
      const isOTM =
        url.hostname?.includes('otmgtm') &&
        url.hostname?.includes('.oraclecloud.com');

      if (!isOTM) {
        return false;
      }

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      return doc.querySelector('input[name^="new_bid_"]') !== null;
    } catch (error: unknown) {
      captureException(error, { context: 'Error checking OTM quote page' });
      return false;
    }
  }
}
